import React from 'react';
import { FadeIn } from './FadeIn';
import { HomeIcon, BookOpenIcon, GiftIcon, StarIcon } from 'lucide-react';
export function StatsAndTestimonials() {
  return <section className="py-10 bg-surfaceLight/50 border-y border-slate-200 relative overflow-hidden" data-id="element-416">
      <div className="container mx-auto px-4" data-id="element-417">
        <FadeIn data-id="element-418">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 divide-x-0 md:divide-x divide-slate-200 mb-10" data-id="element-419">
            <div className="flex flex-col items-center text-center px-4" data-id="element-420">
              <HomeIcon className="w-6 h-6 text-primary mb-2" aria-hidden="true" data-id="element-421" />
              <span className="text-2xl font-extrabold text-slate-900 font-heading" data-id="element-422">
                +800
              </span>
              <span className="text-xs text-slate-500 font-bold mt-1" data-id="element-423">
                Familias confían
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-424">
              <BookOpenIcon className="w-6 h-6 text-primary mb-2" aria-hidden="true" data-id="element-425" />
              <span className="text-2xl font-extrabold text-slate-900 font-heading" data-id="element-426">
                5
              </span>
              <span className="text-xs text-slate-500 font-bold mt-1" data-id="element-427">
                Tomos listos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-428">
              <GiftIcon className="w-6 h-6 text-primary mb-2" aria-hidden="true" data-id="element-429" />
              <span className="text-2xl font-extrabold text-slate-900 font-heading" data-id="element-430">
                3
              </span>
              <span className="text-xs text-slate-500 font-bold mt-1" data-id="element-431">
                Bonos incluidos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-432">
              <div className="flex gap-1 mb-2" data-id="element-433">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber text-amber" data-id="element-434" />)}
              </div>
              <span className="text-2xl font-extrabold text-slate-900 font-heading" data-id="element-435">
                4.9/5
              </span>
              <span className="text-xs text-slate-500 font-bold mt-1" data-id="element-436">
                Calificación
              </span>
            </div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-5" data-id="element-437">
          <FadeIn delay={0.1} data-id="element-438">
            <div className="bg-white p-6 rounded-2xl shadow-soft border border-slate-100 h-full flex flex-col hover:shadow-soft-lg transition-shadow" data-id="element-439">
              <div className="flex gap-1 mb-3" data-id="element-440">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-amber text-amber" data-id="element-441" />)}
              </div>
              <p className="text-slate-700 italic mb-5 flex-grow text-base leading-snug" data-id="element-442">
                "La primera semana que apliqué el método del Tomo 2 fue
                diferente. Mi hijo terminó la sesión diciéndome 'papi, ¿mañana
                hacemos más?' No podía creerlo."
              </p>
              <div className="flex items-center gap-3" data-id="element-443">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center font-bold text-primary-dark font-heading text-lg" data-id="element-444">
                  A
                </div>
                <div data-id="element-445">
                  <p className="font-bold text-slate-900 text-sm" data-id="element-446">Andrea R.</p>
                  <p className="text-xs text-slate-500" data-id="element-447">
                    Córdoba · Mamá de Tomás, 9 años
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-448">
            <div className="bg-white p-6 rounded-2xl shadow-soft border border-slate-100 h-full flex flex-col hover:shadow-soft-lg transition-shadow" data-id="element-449">
              <div className="flex gap-1 mb-3" data-id="element-450">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-amber text-amber" data-id="element-451" />)}
              </div>
              <p className="text-slate-700 italic mb-5 flex-grow text-base leading-snug" data-id="element-452">
                "Siempre llegaba a la hora de la tarea sin saber si estaba
                explicando bien o mal. Eso cambió. Tengo el método claro, sé
                cómo guiarlo y ya no terminamos peleando."
              </p>
              <div className="flex items-center gap-3" data-id="element-453">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center font-bold text-primary-dark font-heading text-lg" data-id="element-454">
                  M
                </div>
                <div data-id="element-455">
                  <p className="font-bold text-slate-900 text-sm" data-id="element-456">Marcelo P.</p>
                  <p className="text-xs text-slate-500" data-id="element-457">
                    Buenos Aires · Papá de Valentina, 10 años
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-458">
            <div className="bg-white p-6 rounded-2xl shadow-soft border border-slate-100 h-full flex flex-col hover:shadow-soft-lg transition-shadow" data-id="element-459">
              <div className="flex gap-1 mb-3" data-id="element-460">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-amber text-amber" data-id="element-461" />)}
              </div>
              <p className="text-slate-700 italic mb-5 flex-grow text-base leading-snug" data-id="element-462">
                "El Tomo 3 de fracciones me hizo darme cuenta que yo nunca supe
                explicar bien ese tema. Con el método de la pizza lo entendió en
                20 minutos después de meses de fracasos."
              </p>
              <div className="flex items-center gap-3" data-id="element-463">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center font-bold text-primary-dark font-heading text-lg" data-id="element-464">
                  L
                </div>
                <div data-id="element-465">
                  <p className="font-bold text-slate-900 text-sm" data-id="element-466">Laura C.</p>
                  <p className="text-xs text-slate-500" data-id="element-467">
                    Rosario · Mamá de Sofía, 8 años
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}